export default "__VITE_ASSET__DquljsKK__"